module.exports = __webpack_public_path__ + "img/zhuxian.6ac3bfb9.png";